type GameListType = {
    isResult?: boolean
    children?: any
}

export default function GameList({isResult = false, children}: GameListType) {
    return (
        <div className={`eo-game-list${isResult ? ' m-results' : ''}`}>
            {children}
        </div>
    )
}
